export default {
  'meta': {
    'langName': 'CROATIAN',
    'lang': 'Hrvatski'
  },
  'title': 'POVLAČENJE PROIZVODA BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'Utvrdili smo rizik od pada šipke iz košarkaškog koša B900,\nako se koristi bez ručke i ako se njime rukuje.\n\nRadi svoje sigurnosti, odmah prekinite svaku upotrebu bez\nugrađene ručke za podešavanje visine. Proizvod ćete moći osigurati jednostavnim\npostupkom pomoću kompleta za popravak, koji će vam biti dostavljen besplatno.\n\nWeb stranica posvećena ovom opozivu trenutno je u izradi.\nVodit će vas kroz korake potrebne za izvođenje ovog postupka. Obavijestit ćemo\nvas čim bude dostupna (tijekom srpnja).',
  'status': 'Translation validated by COUNTRY'
} as const
